import axios from "axios";
import { url } from "../utils/config";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Table from "../reusable_components/Table";
import { useNavigate } from "react-router-dom";
import Button from "../reusable_components/Button";
import { render } from "@testing-library/react";
import { btnOne, title } from "../utils/style";
import { setLoader } from "../reusable_components/Loader";
import formatNumberToUs from "../custom_functions/formatNumberToUs";


function PendingInvoices() {
    const navigate = useNavigate()
    const [ pendingInvoices, setPendingInvoices ] = useState([])
    const [ invoiceIndex, setInvoiceIndex ] = useState(0)

    useEffect(() => {
        // uploadInvoices({})
        getPendingInvoices()
        // const query = window.location.search;
        // if(query && query.length > 0) {
        //     const splitedList = query.split('?')[1]
        //     const splitedList1 = splitedList.split('&')
        //     let code = splitedList1[0].split("=")[1];
        //     let state = splitedList1[1].split("=")[1];
        //     let realmId = splitedList1[2].split("=")[1];
        //     console.log({code, state, realmId});
        //     uploadInvoices({code, state, realmId})
        // }
    }, [])

    async function getPendingInvoices() {
        try {
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(url + '/pending_invoices', { headers })
            console.log(data.data)
            setPendingInvoices(data.data)
        } catch (error) {
            console.log(error)
        }
    }

    async function uploadInvoices(body) {
        try {
            // const quickBookUrl = `${window.location.origin}/finance/pending_invoices`
            setLoader(true)
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const data = await axios.post(url + '/batch_upload_invoice', body, { headers })
            console.log(data)
            toast.success(data.data.message, { autoClose: 3000 })
            navigate('/finance/pending_invoices')
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message, { autoClose: 3000 })
        } finally {
            setLoader(false)
        }
    }

    // async function authorizeQb() {
    //     try {
    //         const token = window.localStorage.getItem('token');
    //         const headers = { authorization: `bearer ${token}` };
    //         const redirectUri = `${window.location.origin}/finance/pending_invoices`
    //         const data = await axios.post(url + '/qb_auth_url', { redirectUri }, { headers })
    //         console.log(data.data.data)
            
    //         window.location.replace(data.data.data)
    //     } catch (error) {
    //         console.log(error) 
    //     }
    // }

    const options = [
        {
            header: 'Id',
            key: 'id',
            
        },{
            header: 'Bundle Items',
            render: (data)=>{
                return JSON.parse(data.bundleList).data.map((d, ind) =>
                     (<div className="flex justify-between">
                        <div className="text-sm mr-4 flex justify-between"><span className="mr-4 font-bold capitalize">{d.name}</span></div>
                        <div><span className="font-bold">{d.cost}</span><span className="ml-3">{d.currency}</span></div>
                        </div>
                     ));
            }   

        },{
            header: 'Service Items',
            // key: 'serviceList',
            render: (data)=>{
                return JSON.parse(data.serviceList).data.map((d, ind) =>
                     (<div className="flex justify-between">
                        <div className="text-sm mr-4 flex justify-between"><span className="mr-4 font-bold capitalize">{d.name}</span></div>
                        <div><span className="font-bold">{d.estimatedTime}</span><span className="ml-3">{d.currency}</span></div>
                        </div>
                     ));
            }   
        },
        {
            header: 'Material Items',
            // key: 'materialList',
            render: (data)=>{
                return JSON.parse(data.materialList).data.map((d, ind) =>
                     (<div className="flex justify-between">
                        <div className="text-sm mr-4 flex justify-between"><span className="mr-4 font-bold capitalize">{d.name}</span></div>
                        <div><span className="font-bold">{d.estimatedTime}</span><span className="ml-3">{d.currency}</span></div>
                        </div>
                     ));
            }   
        },
        {
            header: 'Other Items',
            // key: 'otherList',
            render: (data)=>{
                return JSON.parse(data.otherList).data.map((d, ind) =>
                     (<div className="flex justify-between">
                        <div className="text-sm mr-4 flex justify-between "><span className="mr-4 font-bold capitalize">{d.name}</span></div>
                        <div><span className="font-bold">{d.estimatedTime}</span><span className="ml-3">{d.currency}</span></div>
                        </div>
                     ));
            }   
        }
    ]

    return(
        <div className="p-4">
            <div className="flex justify-between">
                <div className={title}>Pending Invoices</div>
            </div>
            <div className="py-2 flex justify-center">
                <span><Button name={'Connect Quickbooks And Upload'} clickHandler={uploadInvoices} className={btnOne}/></span>
            </div>

            <div className="flex py-2 gap-8">
                <div className="basis-1/3 border-r border-gray-300 pr-4">
                    {
                        pendingInvoices.map((inv, ind) => 
                            <div key={ind} className="px-2 py-4 shadow-md mb-4 flex justify-between items-center rounded-lg">
                                <div className="text-sm">{`INV00${inv.id}`}</div>
                                <div className="text-xs text-customOne cursor-pointer" onClick={() => setInvoiceIndex(ind)}>{`View Invoice >`}</div>
                            </div>
                        )
                    }
                </div>
                {
                    pendingInvoices.length > 0 &&
                    <div className="basis-2/3">
                    <div>
                        <div>Details Of Invoice</div>
                        <div></div>
                    </div>
                    <div>
                        <div className={title}>Bundle Items</div>
                        {
                            <div className="flex items-center border border-gray-300 py-2 text-sm mt-2">
                                <div className="basis-1/2 text-center font-semibold">Name</div>
                                <div className="basis-1/2 text-center font-semibold">Amount</div>
                            </div>
                        }
                        <div>
                            {
                                JSON.parse(pendingInvoices[invoiceIndex]?.bundleList)?.data?.map((bl, ind) => 
                                    <div key={ind} className="flex items-center border border-gray-300 py-2 text-sm">
                                        <div className="basis-1/2 text-center">{bl.name}</div>
                                        <div className="basis-1/2 text-center">{formatNumberToUs(bl.cost?.toFixed(2))}</div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    
                    <div>
                        <div className={title}>Service Items</div>
                        {
                            <div className="flex items-center border border-gray-300 py-2 text-sm mt-2">
                                <div className="basis-1/2 text-center font-semibold">Name</div>
                                <div className="basis-1/2 text-center font-semibold">Estimated Time (mins)</div>
                            </div>
                        }
                        <div>
                            {
                                JSON.parse(pendingInvoices[invoiceIndex]?.serviceList)?.data?.map((sl, ind) => 
                                    <div key={ind} className="flex items-center border border-gray-300 py-2 text-sm">
                                        <div className="basis-1/2 text-center">{sl.name}</div>
                                        <div className="basis-1/2 text-center">{sl.estimatedTime}</div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    
                    <div>
                        <div className={title}>Parts</div>
                        {
                            <div className="flex items-center border border-gray-300 py-2 text-sm mt-2">
                                <div className="basis-1/2 text-center font-semibold">Name</div>
                                <div className="basis-1/2 text-center font-semibold">Amount</div>
                            </div>
                        }
                        <div>
                            {
                                JSON.parse(pendingInvoices[invoiceIndex]?.materialList)?.data?.map((ml, ind) => 
                                    <div key={ind} className="flex items-center border border-gray-300 py-2 text-sm">
                                        <div className="basis-1/2 text-center">{ml.name}</div>
                                        <div className="basis-1/2 text-center">{formatNumberToUs(ml.cost?.toFixed(2))}</div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    
                    <div>
                        <div className={title}>Other Items</div>
                        {
                            <div className="flex items-center border border-gray-300 py-2 text-sm mt-2">
                                <div className="basis-1/2 text-center font-semibold">Name</div>
                                <div className="basis-1/2 text-center font-semibold">Estimated Time (mins)</div>
                            </div>
                        }
                        <div>
                            {
                                JSON.parse(pendingInvoices[invoiceIndex]?.otherList)?.data?.map((ol, ind) => 
                                    <div key={ind} className="flex items-center border border-gray-300 py-2 text-sm">
                                        <div className="basis-1/2 text-center">{ol.name}</div>
                                        <div className="basis-1/2 text-center">{ol.estimatedTime}</div>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div >
                        <div className="flex justify-end p-2 gap-8">
                            <div className="text-sm font-semibold">Subtotal</div>
                            <div className="text-sm">${formatNumberToUs(pendingInvoices[invoiceIndex]?.materialCost?.toFixed(2))}</div>
                        </div>
                        <div className="flex justify-end p-2 gap-8">
                            <div className="text-sm font-semibold">Total</div>
                            <div className="text-sm">${formatNumberToUs((pendingInvoices[invoiceIndex]?.totalCost + pendingInvoices[invoiceIndex]?.materialCost)?.toFixed(2))}</div>
                        </div>
                    </div>
                </div>}
            </div>

            {/* <Table 
                options={options} 
                url={url + '/pending_invoices'} 
                pagination 
                noButton
            /> */}
        </div>
    )
}

export default PendingInvoices;